import React from 'react'
import { ActionCard as ActionCardModel } from '../models/ActionCard'
import { Tab, Tabs } from '@mui/material'
import { observer } from 'mobx-react'
import { computed, observable, makeObservable } from 'mobx';
import _ from 'lodash'
import { ActionCard } from './ActionCard'
import {ActionDetail, Header3, Header4, HomeGreeting, HomeText} from "../styles/App.styles";
import {PaymentPlansTabContainer} from "../styles/Payment.styles";

type Props = {
  greeting?: string
  text?: string
  detail?: {
    imageSource: string | undefined
    label: string | undefined
    value: string | undefined
  }
  cards: ActionCardModel[]
  onQuickActionClicked: (actionCard: ActionCardModel) => void
  collapseMobile?: boolean
}

export const ActionCardsList = observer(class ActionCardsList extends React.Component<Props> {
  private selectedTab?: string;

  constructor(props: Props) {
    super(props);

    makeObservable<ActionCardsList, "selectedTab" | "actionCardCategories" | "activeTab" | "visibleActionCards">(this, {
      selectedTab: observable,
      actionCardCategories: computed,
      activeTab: computed,
      visibleActionCards: computed
    });
  }

  private get actionCardCategories() {
    return _.uniq(this.props.cards.map(c => c.category) ?? [])
  }

  private get activeTab() {
    return this.selectedTab ?? (this.actionCardCategories.length ? this.actionCardCategories[0] : undefined)
  }

  private get visibleActionCards() {
    if (this.actionCardCategories.length < 2) {
      return this.props.cards
    }

    return this.props.cards.filter(c => c.category === this.activeTab)
  }

  render () {
    return <>
      {
        this.actionCardCategories.length > 1
          ? <PaymentPlansTabContainer>
            <Tabs indicatorColor="secondary" textColor="inherit" value={this.activeTab} onChange={(ev, value) => this.selectedTab = value} variant="fullWidth">
              {
                this.actionCardCategories.map(cat => <Tab key={cat} label={cat} value={cat}/>)
              }
            </Tabs>
          </PaymentPlansTabContainer>
          : null
      }
      {
        this.props.greeting
          ? <HomeGreeting>{this.props.greeting}</HomeGreeting>
          : null
      }
      {
        this.props.text
          ? <HomeText>{this.props.text}</HomeText>
          : null
      }
      {
        this.props.detail
          ? <ActionDetail className="hide-desktop" style={{ marginBottom: 20 }}>
            <Header3>{this.props.detail.label}</Header3>
            <Header4>{this.props.detail.value}</Header4>
          </ActionDetail>
          : null
      }
      <div className="action-cards-list">
        {
          this.visibleActionCards.map((actionCard, idx) => <ActionCard collapseMobile={this.props.collapseMobile} key={idx} actionCard={actionCard} onQuickActionClicked={this.props.onQuickActionClicked}/>)
        }
      </div>
    </>
  }
});
